import Input from "../../../../components/general/Input";
import Button from "../../../../components/general/Button";
import { SearchIcon, AddCircleIcon } from "../../../ModelFlows/Icons";
import { FilterOptionsButton } from "../FilterOptionsButton";

/**
 * @param {Object} props
 * @param {string} props.titleSearch
 * @param {function(string):void} props.setTitleSearch
 * @param {Object} props.typeFilter
 * @param {function(Object):void} props.updateFilters
 * @param {boolean} props.openFilterOptions
 * @param {function(boolean):void} props.setOpenFilterOptions
 * @param {function(Object):void} props.setUrlParams
 * @param {function():void} props.onClickButton
 */
const SearchSection = ({
  titleSearch,
  setTitleSearch,
  openFilterOptions,
  setOpenFilterOptions,
  onClickButton,
  filterOptions,
  onSelectNoneOption,
}) => {
  const handleSetTitleSearch = (value) => {
    setTitleSearch(value.replace(/^ +/, ""));
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        maxHeight: "25px",
      }}
    >
      <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ width: "20.8rem" }}>
          <Input
            value={titleSearch}
            setValue={handleSetTitleSearch}
            Icon={() => <SearchIcon />}
            placeholder="Pesquise a partir de 3 letras..."
            buttonConfirmText="Pesquisar"
          />
        </div>
        <div style={{ height: "2.68rem" }}>
          <FilterOptionsButton
            open={openFilterOptions}
            setOpen={setOpenFilterOptions}
            onSelectNone={onSelectNoneOption}
            options={filterOptions}
          />
        </div>
      </div>
      <Button
        Icon={() => <AddCircleIcon />}
        onClick={onClickButton}
        content="Novo RDM"
        style={{
          fontFamily: "Sora",
          width: "10.3rem",
          height: "2.68rem",
          right: "0",
        }}
        marginText="0.45rem"
      />
    </div>
  );
};

export default SearchSection;
